import { render, staticRenderFns } from "./BreadCrumbsDisabledElement.vue?vue&type=template&id=579e99fc"
import script from "./BreadCrumbsDisabledElement.vue?vue&type=script&lang=js"
export * from "./BreadCrumbsDisabledElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports